import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Page from 'components/widgets/Route';
import * as actions from './actions';
import Credentials from './container/Credentials';

class CredentialsRoute extends React.Component {
	constructor(props) {
		super(props);
		this.fetchCredentials = this.fetchCredentials.bind(this);
	}

	fetchCredentials() {
		this.props.actions.fetchCredentials();
	}

	render() {
		const { match: { path } } = this.props;
		return (
			<Page>
				<Page.Route
					exact
					path={path}
					onEnter={this.fetchCredentials}
					component={Credentials}
				/>
			</Page>
		);
	}
}

CredentialsRoute.propTypes = {
	match: PropTypes.shape({
		path: PropTypes.string.isRequired
	}).isRequired
};

function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(actions, dispatch)
	};
}

export default connect(
	null,
	mapDispatchToProps
)(CredentialsRoute);
